import {cloneDeep, isEmpty} from 'lodash'
import helper from '@/lib/helper'

export default {
  namespaced: true,

  state: {
    show: false,
    signed: false,
    mktSigned: false,

    tMap: {},
    mMap: {},
    cache: null,
  },
  getters: {
    tCodes: (s) => {
      if (isEmpty(s.tMap)) {
        return []
      }
      return Object.keys(s.tMap).filter((k) => s.tMap[k])
    },
    mCodes: (s) => {
      if (isEmpty(s.mMap)) {
        return []
      }
      return Object.keys(s.mMap).filter((k) => s.mMap[k])
    },
  },
  mutations: {
    signed: (s, b) => (s.signed = b),
    mktSigned: (s, b) => (s.mktSigned = b),
    tMap: (s, o) => (s.tMap = o),
    mMap: (s, o) => (s.mMap = o),
    cache: (s, o) => (s.cache = o),

    show: (s, b) => {
      s.show = b
      s.cache = b ? cloneDeep(s) : null
    },
    reset: (s) => {
      s.signed = false
      s.mktSigned = false
      s.show = false
      s.tMap = {}
      s.mMap = {}
      s.cache = null
    },
  },
  actions: {
    revert({commit, state}) {
      if (!state.cache) {
        return
      }
      const cache = cloneDeep(state.cache)
      Object.keys(state).forEach((key) => commit(key, cache[key]))
      commit('show', false)
    },
    async save({commit, getters, rootGetters}, p) {
      // wait for register.event
      let i = 0
      const n = 40
      while (!rootGetters['register/event']) {
        await helper.sleep(200)
        if (i++ > n) {
          return
        }
      }
      const {toa} = rootGetters['register/event'].options
      commit('tMap', p.tMap)
      commit('mMap', p.mMap)

      const b = getters.tCodes.length == toa.length
      commit('signed', b)
      
      const {mkt} = rootGetters['register/event'].options
      const m = getters.mCodes.length == mkt.length
      commit('mktSigned', m)
      
      commit('show', false)
    },
  },
}
